import * as types from "./ActionTypes";
import Api from "../api/UsersApi";

export const getLinkedUsers = () => {
    return (dispatch) => {
        return Api.getLinkedUsers()
            .then((data) => {
                dispatch({ type: types.GET_LINKED_USERS_SUCCEEDED, users: data });
            })
            .catch((error) => {
                dispatch({ type: types.GET_LINKED_USERS_FAILED, error });
                throw(error);
            });
    };
};

export const deleteUserLink = (userId) => {
    return (dispatch) => {
        return Api.deleteUserLink(userId)
            .then(() => {
                dispatch({ type: types.DELETE_USER_LINK_SUCCEEDED });
            })
            .catch((error) => {
                dispatch({ type: types.DELETE_USER_LINK_FAILED, error });
                throw(error);
            });
    };
};

export const linkUserToSite = (site, login, password) => {
    return (dispatch) => {
        return Api.linkUserToSite(site, login, password)
            .then((data) => {
                dispatch({ type: types.LINK_USER_TO_SITE_SUCCEEDED, users: data });
            })
            .catch((error) => {
                dispatch({ type: types.LINK_USER_TO_SITE_FAILED, error });
                throw(error);
            });
    };
};

export const getLinkedSites = (virtualProductId) => {
    return (dispatch) => {
        return Api.getLinkedUsersByProduct(virtualProductId)
            .then((data) => {
                dispatch({ type: types.GET_LINKED_USERS_SUCCEEDED, users: data });
            })
            .catch((error) => {
                dispatch({ type: types.GET_LINKED_USERS_FAILED, error });
                throw(error);
            });
    };
};

export const clearErrorMessage = () => {
    return { type: types.CLEAR_ERROR_MESSAGE };
};

export const getUsersByOrgId = (orgId, excludeInactive, filterByProductId, filterByTeamId) => {
    return (dispatch) => {
        return Api.getUsersByOrgId(orgId, excludeInactive, filterByProductId, filterByTeamId)
            .then((users) => {
                dispatch({ type: types.GET_USERS_BY_ORG_SUCCEEDED, users });
            })
            .catch((error) => {
                dispatch({ type: types.GET_USERS_BY_ORG_FAILED, error });
                throw(error);
            });
    };
};

